
var ip = process.env.REACT_APP_API_URL == "https://si24-ip.sirisk.online/api" //|| process.env.REACT_APP_API_URL == "http://localhost:5000/api"
exports.wholeDateFormat = (ip ? 'MM-DD-YYYY' : "DD-MM-YYYY")
exports.hourFormat = (ip ? 'MM-DD-YYYY HH:mm:ss' : 'DD-MM-YYYY HH:mm:ss')
exports.time = "HH:mm:ss"
